module.exports = __webpack_public_path__ + "static/img/splitscreen.889d6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/meetingcontrol/black/splitscreen.png
// module id = hgY0
// module chunks = 1